import apiSlice from "./ApiSlice";

export const contactApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get List Pagination Contact
    getContactListPagination: builder.query({
      providesTags: ["inquiry", "followup"],
      query: (body) => {
        return {
          url: "/contact",
          method: "POST",
          body,
        };
      },
    }),
    //Contact Single View
    viewSingleContact: builder.query({
      providesTags: ["inquiry"],
      query: (id: any) => {
        return {
          url: `/contact/${id}`,
          method: "GET",
        };
      },
    }),
    // Add Contact
    addContact: builder.mutation({
      invalidatesTags: ["inquiry"],
      query: (body) => {
        return {
          url: "/contact/add",
          method: "POST",
          body,
        };
      },
    }),

    // Contact Update
    updateContact: builder.mutation({
      invalidatesTags: ["inquiry"],
      query: ({ body, id }: any) => {
        return {
          url: `/contact/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    // ADD Contact Note
    addContactNote: builder.mutation({
      invalidatesTags: ["inquiry"],
      query: (body: any) => {
        return {
          url: "/contact-note/add",
          method: "POST",
          body,
        };
      },
    }),
    // contact note listing
    getContactNoteListPagination: builder.query({
      providesTags: ["inquiry", "followup"],
      query: (body) => {
        return {
          url: "/contact-note",
          method: "POST",
          body,
        };
      },
    }),
    // Contact Note Update
    updateContactNote: builder.mutation({
      invalidatesTags: ["inquiry"],
      query: ({ body, id }: any) => {
        return {
          url: `/contact-note/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    //Contact Queue
    getQueueList: builder.query({
      providesTags: ["inquiry"],
      query: (id: any) => {
        return {
          url: `/queue`,
          method: "GET",
        };
      },
    }),
    // Add Contact Task
    addContactTask: builder.mutation({
      invalidatesTags: ["inquiry"],
      query: (body) => {
        return {
          url: "/contact-task/add",
          method: "POST",
          body,
        };
      },
    }),
     // Add Contact Task
     updateContactTask: builder.mutation({
      invalidatesTags: ["inquiry"],
      query: ({body , id}:any) => {
        return {
          url: `/contact-task/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    // Add Contact Log
    addContactLogs: builder.mutation({
      invalidatesTags: ["inquiry"],
      query: (body) => {
        return {
          url: "/contact-log/add",
          method: "POST",
          body,
        };
      },
    }),
    //Contact Queue
    getOverViewListing: builder.query({
      providesTags: ["inquiry"],
      query: (id: any) => {
        return {
          url: `/contact/${id}/actions`,
          method: "GET",
        };
      },
    }),
    // Get List Pagination Contact Task
    getContactTaskList: builder.query({
      providesTags: ["inquiry"],
      query: (body) => {
        return {
          url: "/contact-task",
          method: "POST",
          body,
        };
      },
    }),
    // Get Email Logs 
    getLogspagination: builder.query({
      providesTags: ["inquiry"],
      query: (body: any) => {
        return {
          url: `/contact-log`,
          method: "POST",
          body ,
        };
      },
    }),

    //Update Contact Log
    updateContactLog: builder.mutation({
      invalidatesTags: ["inquiry"],
      query: ({body ,Id}:any) => {
        return {
          url: `/contact-log/${Id}`,
          method: "PUT",
          body,
        };
      },
    }),
    //Contact LifeCycle Stage
    getLifeCycleStage: builder.query({
      providesTags: ["inquiry"],
      query: () => {
        return {
          url: `/lifecycle-stage`,
          method: "GET",
        };
      },
    }),
    // Add lifecycle-stage
    addLifeCycleStage: builder.mutation({
      invalidatesTags: ["inquiry"],
      query: (body) => {
        return {
          url: "/lifecycle-stage/add",
          method: "POST",
          body,
        };
      },
    }),
  }),
});

export const {
  useAddContactNoteMutation,
  useGetContactListPaginationQuery,
  useUpdateContactMutation,
  useViewSingleContactQuery,
  useAddContactMutation,
  useGetContactNoteListPaginationQuery,
  useUpdateContactNoteMutation,
  useGetQueueListQuery,
  useAddContactTaskMutation,
  useAddContactLogsMutation,
  useGetOverViewListingQuery,
  useGetContactTaskListQuery,
  useUpdateContactTaskMutation ,
  useGetLogspaginationQuery,
  useUpdateContactLogMutation,
  useGetLifeCycleStageQuery,
  useAddLifeCycleStageMutation
} = contactApi;
